import React from "react";
import {useHistory} from "react-router";
import {SearchExperience} from "./SearchExperience";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import {useTranslation} from "react-i18next";

interface Props {
  publicToken?: string
  pathname: string
  isMain?: boolean
  busqueda?: string
  setBusqueda?: any
  setLoaded?: any
  dropdown?
  openCloseDropdown?
  idiomaHandler?
  clientName?
}

export const HeaderView = ({publicToken, pathname, isMain, busqueda, setBusqueda, setLoaded, dropdown, openCloseDropdown, idiomaHandler, clientName}: Props) => {
  const history = useHistory()
  const [t,] = useTranslation("global");

  return (
    <header className="book-embed-nav with-padding respond-print-hide">
      <div className="">
        <ul className="">
          <li className="test-flow-node-breadcrumb" style={{marginRight: 4}}>
            <button
              className="ben-item fade-in-up cart-button"
              type="button"
              aria-expanded="false"
              onClick={() => {
                if (pathname) {
                  history.push(pathname)
                }
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                id="icon-cart"
                className="icon-cart"
                width="27" height="23" viewBox="0 0 27 23" style={{fill: '#33488e'}}
              >
                <path d="M24.47,16.68H7.12l-3.74-14H.08V.21H5.42l3.74,14H22.31l1.58-8.48H11.25V3.22H26.92Z"/>
                <path d="M23,20.59a2.2,2.2,0,1,0-2.2,2.2A2.19,2.19,0,0,0,23,20.59Z"/>
                <path d="M12.19,20.59A2.2,2.2,0,1,0,10,22.79,2.19,2.19,0,0,0,12.19,20.59Z"/>
              </svg>
              {/*<span className="respond-handhelds-hide">{t("cart")}</span>*/}
              <span className="respond-desktop-hide"/>
            </button>
          </li>

          {clientName &&
            <li className="ben-flyout-wrap">
            <span className="ben-item ben-translate-button capitalize" style={{
              fontSize: 'medium',
              backgroundColor: '#33488e',
              color: 'white',
              borderLeft: '1px solid',
              marginLeft: 7
            }}
            >
              {clientName}
            </span>
          </li>}

        </ul>
        {
          isMain &&
          <>
            <li style={{textAlign: 'right'}}>
              <SearchExperience
                busqueda={busqueda}
                setBusqueda={setBusqueda}
                setLoaded={setLoaded}
                publicToken={publicToken}
              />
            </li>
            <button className="btn btn-info" style={{marginRight: '110px', backgroundColor: '#33488e'}}>
              <FontAwesomeIcon icon={faSearch}/>
            </button>
          </>
        }
      </div>
    </header>
  )
}
